import Img from 'components/Img';
import PlainButton from 'components/PlainButton';
import type { Review, ReviewImage } from 'models/api';
import { cn } from 'utils/classNames';

import type { ImageReviewItem } from '../hooks';

export interface ReviewImageClickArgs {
	image: ReviewImage;
	index: number;
	review: Review;
}

interface Props {
	buttonLabel: string;
	className?: string;
	images: ImageReviewItem[] | undefined;
	onImageClick: (args: ReviewImageClickArgs) => void;
}

export default function ReviewImageThumbnails({
	buttonLabel,
	className,
	images,
	onImageClick,
}: Props) {
	if (!images?.length) {
		return null;
	}

	return (
		<ul className={cn('flex flex-wrap gap-4', className)}>
			{images.map((image, i) => (
				<li key={image.icon}>
					<PlainButton
						onClick={() => {
							onImageClick({ image, index: i, review: image.review });
						}}
						aria-label={buttonLabel}
						aria-haspopup="dialog"
						className="inline-block overflow-hidden rounded-xs align-top hover:not-focus-visible:outline hover:not-focus-visible:outline-offset-[3px]"
					>
						<Img
							key={image.icon}
							src={image.icon}
							alt=""
							className="size-16"
							width={image.iconWidth}
							height={image.iconHeight}
						/>
					</PlainButton>
				</li>
			))}
		</ul>
	);
}
ReviewImageThumbnails.displayName = 'ReviewImageThumbnails';
